import { Fragment, useEffect, useState } from "react";
import { TabPurchases, TabNavTransaction, TabSalesOrder, TabInvoice, TabSKU, TabBuild, TabAdjusment, TabCount, TabTransfers } from "../ChildItem/components/Item/components/FormTransaction";
import { TabBill } from "../ChildItem/components/Item/components/FormTransaction/TabBill";
import moment from "moment";
import { FilterType } from "../../types"
import { FilterTransaction } from "../FilterTransaction";

export const FormTransaction = (props: { product_id?: number; disable?: boolean }) => {
  // Hooks
  const [activeTab, setActiveTab] = useState<string>("")

  const [filter, setFilter] = useState<FilterType>({
    dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
    dateEnd: moment().format("YYYY-MM-DD"),
  })

  useEffect(() => {
    if (props?.product_id) {
      localStorage.setItem("prdId", props.product_id.toString());
    }
  }, [props?.product_id])

  return (
    <Fragment>
      <section className="container">
        <section className="mb-3">
          <FilterTransaction
            dateFrom={filter.dateFrom}
            dateEnd={filter.dateEnd}
            onChangeDateFrom={(date: string) => {
              setFilter(prev => ({ ...prev, dateFrom: date }));
            }}

            onChangeDateEnd={(date: string) => {
              setFilter(prev => ({ ...prev, dateEnd: date }));
            }}
          />
        </section>
        <section className="mt-1">
          <TabNavTransaction activeTab={activeTab!} setActiveTab={setActiveTab} />
          <section className="border-[1px] border-[#3c3c3c] ml-[1px] p-2 z-[100]!">
            {activeTab === "adjustment" &&
              <TabAdjusment
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }

            {activeTab === "count-inventory" &&
              <TabCount
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }
            {activeTab === "transfers" &&
              <TabTransfers
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }

            {activeTab === "sku-attached" &&
              <TabSKU
                disable={props?.disable}
              />
            }
            {activeTab === "purchases" &&
              <TabPurchases
                disable={props?.disable}
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }
            {activeTab === "build" &&
              <TabBuild
                disable={props?.disable}
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }
            {activeTab === "sales-order" &&
              <TabSalesOrder
                disable={props?.disable}
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }
            {activeTab === "bills" &&
              <TabBill
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
                disable={props?.disable} />
            }
            {activeTab === "invoice" &&
              <TabInvoice
                dateFrom={filter.dateFrom}
                dateEnd={filter.dateEnd}
              />
            }
          </section>
        </section>
      </section>
    </Fragment>
  )
}